import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  DirectorIndentFilter,
  GetDirectorDepartmentList,
  GetDirectorIndentList
} from "../../Repository/Api";
import { errorMsg, successMsg } from "../Toastify";

const DirectorIndentlistrequest = () => {
  const { first_name, department, access_token } = useSelector((state) => state?.auth?.auth);
  const token = access_token

  const [indentList, setIndentList] = useState([]);
  const [indentFilterList, setIndentFilterList] = useState([]);
  const [createIndent, setCreateIndent] = useState([]);
  const [departmentt, setDepartment] = useState([]);

  useEffect(() => {
    getIndentList();
    getDepartment();
  },[]);

  const [active, setActive] = useState(0);
  const links = ["Pending", "Partially Approved", "Approved", "Rejected"];
  const showSelected = (index) => {
    setActive(index);
  };

  const getIndentList = async () => {
    const response = await GetDirectorIndentList(token);
    if (response && response.statusCode === 200) {
      setIndentList(response?.data?.purchase_history);
    } else {
      errorMsg(response.message);
    }
  };
  const getDepartment = async () => {
    const response = await GetDirectorDepartmentList(token);
    if (response && response.statusCode === 200) {
      setDepartment(response?.data?.department);
    } else {
      errorMsg(response.message);
    }
  };

  const pendingLeaveLength = indentList.filter(
    (item) => item.director_status === "pending"
  ).length;
  const partialapprovedIndentLength = indentList.filter(
    (item) => item.director_status === "partially_approved"
  ).length;
  const approveLeaveLength = indentList.filter(
    (item) => item.director_status === "approved"
  ).length;
  const rejectLeaveLength = indentList.filter(
    (item) => item.director_status === "rejected"
  ).length;

  const getIndent = async () => {
    let getdepartment = createIndent?.department_id;
    let getfromDate = createIndent?.start_date;
    let gettoDate = createIndent?.end_date;

    const response = await DirectorIndentFilter(
      getdepartment,
      getfromDate,
      gettoDate,
      token
    );
    if (response && response.statusCode === 200) {
      setIndentFilterList(response?.data?.purchase_history);
      successMsg(response.message);
    } else {
      errorMsg(response.message);
    }
  };

  const setData = (e, key) => {
    let TempData = createIndent;
    TempData[key] = e;
    setCreateIndent(TempData);
  };

  return (
    <>
      <div className="">
        <section className="top-content-container">
          <div className="my-4">
            <div className="row">
              <div className="col-lg-6">
                <h6 className="headertext">{first_name}</h6>
                <h6 className="subheadertext">{department}</h6>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="row">
            <div className="">
              <div className="graphbox">
                <div className="row">
                  <div className="col-lg-3">
                    <h6 className="labeltitle">Indent Form Request</h6>
                  </div>
                  <div className="col-lg-6">
                    <ul className="searchtopflex">
                      {links.map((link, index) => {
                        return (
                          <li
                            onClick={() => showSelected(index)}
                            key={link}
                            className={
                              active === index
                                ? "agenttextactive"
                                : "agenttextinactive"
                            }
                          >
                            {link}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>

                {active === 0 && (
                  <table className="table table-hover mt-5">
                    <thead>
                      <tr>
                        <th scope="col">Indent No</th>
                        <th scope="col">Name</th>
                        <th scope="col">Department</th>
                        <th scope="col">Date</th>
                        <th scope="col">Application</th>
                      </tr>
                    </thead>
                    <tbody>
                      {pendingLeaveLength > 0 ? (
                        indentList &&
                        indentList
                          ?.filter(
                            (indentList) =>
                              indentList.director_status === "pending"
                          )
                          .map((indent, index) => (
                            <tr key={index}>
                              <td>
                                {indent?.indent_number
                                  ? indent?.indent_number
                                  : "-"}
                              </td>
                              <td>
                                {indent?.employee_name
                                  ? indent?.employee_name
                                  : "-"}
                              </td>
                              <td>
                                {indent?.department ? indent?.department : "-"}
                              </td>
                              <td>
                                {moment(indent?.requested_date).format(
                                  "DD MMM YY"
                                )}
                              </td>
                              <td className="viewoption">
                                <Link
                                  to={`/app/Director/DirectorIndentspecificsview/${indent?.id}`}
                                >
                                  View
                                </Link>
                              </td>
                            </tr>
                          ))
                      ) : (
                        <tr>
                          <td></td>
                          <td></td>
                          <td>
                            <div> No Data Found</div>
                          </td>
                          <td></td>
                          <td></td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                )}
                {active === 1 && (
                  <>
                    <div className="row mt-5">
                      <div className="col-lg-10">
                        <div className="row">
                          <div className="col-lg-4">
                            <label className="labeltext">Department</label>
                            <select
                              className="fieldinput"
                              defaultValue={createIndent?.department_id}
                              onChange={(e) => {
                                setData(e.target.value, "department_id");
                              }}
                            >
                              <option value="">Select Department</option>
                              {departmentt?.map((e, index) => (
                                <option key={index} value={e.id}>
                                  {e.name}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="col-lg-4">
                            <div className="mb-3">
                              <label className="labeltext">From Date</label>
                              <input
                                type="date"
                                className="fieldinput"
                                defaultValue={createIndent?.start_date}
                                onChange={(e) => {
                                  setData(e.target.value, "start_date");
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-lg-4">
                            <div className="mb-3">
                              <label className="labeltext">To Date</label>
                              <input
                                type="date"
                                className="fieldinput"
                                defaultValue={createIndent?.end_date}
                                onChange={(e) => {
                                  setData(e.target.value, "end_date");
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-1 mt-auto">
                        <div className="row">
                          <div className="col-lg-3 mt-auto">
                            <div className="mb-3">
                              <button
                                type="button"
                                className="requestbtn"
                                onClick={getIndent}
                              >
                                Search
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <table className="table table-hover mt-5">
                      <thead>
                        <tr>
                          <th scope="col">Indent No</th>
                          <th scope="col">Name</th>
                          <th scope="col">Department</th>
                          <th scope="col">Date</th>
                          <th scope="col">Application</th>
                        </tr>
                      </thead>
                      {indentFilterList.length > 0 ? (
                        <tbody>
                          {indentFilterList.length > 0 ? (
                            indentFilterList &&
                            indentFilterList.map((indent, index) => (
                              <tr key={index}>
                                <td>
                                  {indent?.indent_number
                                    ? indent?.indent_number
                                    : "-"}
                                </td>
                                <td>
                                  {indent?.employee_name
                                    ? indent?.employee_name
                                    : "-"}
                                </td>
                                <td>
                                  {indent?.department
                                    ? indent?.department
                                    : "-"}
                                </td>
                                <td>
                                  {moment(indent?.requested_date).format(
                                    "DD MMM YY"
                                  )}
                                </td>
                                <td className="viewoption">
                                  <Link
                                    to={`/app/Stores/StoreInchargeIndentSpecificView/${indent?.id}`}
                                  >
                                    View
                                  </Link>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td></td>
                              <td></td>
                              <td>
                                <div> No Data Found</div>
                              </td>
                              <td></td>
                              <td></td>
                            </tr>
                          )}
                        </tbody>
                      ) : (
                        <tbody>
                          {partialapprovedIndentLength > 0 ? (
                            indentList &&
                            indentList
                              ?.filter(
                                (indentList) =>
                                  indentList.director_status ===
                                  "partially_approved"
                              )
                              .map((indent, index) => (
                                <tr key={index}>
                                  <td>
                                    {indent?.indent_number
                                      ? indent?.indent_number
                                      : "-"}
                                  </td>
                                  <td>
                                    {indent?.employee_name
                                      ? indent?.employee_name
                                      : "-"}
                                  </td>
                                  <td>
                                    {indent?.department
                                      ? indent?.department
                                      : "-"}
                                  </td>
                                  <td>
                                    {moment(indent?.requested_date).format(
                                      "DD MMM YY"
                                    )}
                                  </td>
                                  <td className="viewoption">
                                    <Link
                                      to={`/app/Director/DirectorIndentspecificsview/${indent?.id}`}
                                    >
                                      View
                                    </Link>
                                  </td>
                                </tr>
                              ))
                          ) : (
                            <tr>
                              <td></td>
                              <td></td>
                              <td>
                                <div> No Data Found</div>
                              </td>
                              <td></td>
                              <td></td>
                            </tr>
                          )}
                        </tbody>
                      )}
                    </table>
                  </>
                )}
                {active === 2 && (
                  <>
                    <div className="row mt-5">
                      <div className="col-lg-10">
                        <div className="row">
                          <div className="col-lg-4">
                            <label className="labeltext">Department</label>
                            <select
                              className="fieldinput"
                              defaultValue={createIndent?.department_id}
                              onChange={(e) => {
                                setData(e.target.value, "department_id");
                              }}
                            >
                              <option value="">Select Department</option>
                              {departmentt?.map((e, index) => (
                                <option key={index} value={e.id}>
                                  {e.name}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="col-lg-4">
                            <div className="mb-3">
                              <label className="labeltext">From Date</label>
                              <input
                                type="date"
                                className="fieldinput"
                                defaultValue={createIndent?.start_date}
                                onChange={(e) => {
                                  setData(e.target.value, "start_date");
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-lg-4">
                            <div className="mb-3">
                              <label className="labeltext">To Date</label>
                              <input
                                type="date"
                                className="fieldinput"
                                defaultValue={createIndent?.end_date}
                                onChange={(e) => {
                                  setData(e.target.value, "end_date");
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-1 mt-auto">
                        <div className="row">
                          <div className="col-lg-3 mt-auto">
                            <div className="mb-3">
                              <button
                                type="button"
                                className="requestbtn"
                                onClick={getIndent}
                              >
                                Search
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <table className="table table-hover mt-5">
                      <thead>
                        <tr>
                          <th scope="col">Indent No</th>
                          <th scope="col">Name</th>
                          <th scope="col">Department</th>
                          <th scope="col">Date</th>
                          <th scope="col">Application</th>
                        </tr>
                      </thead>
                      {indentFilterList.length > 0 ? (
                        <tbody>
                          {indentFilterList.length > 0 ? (
                            indentFilterList &&
                            indentFilterList.map((indent, index) => (
                              <tr key={index}>
                                <td>
                                  {indent?.indent_number
                                    ? indent?.indent_number
                                    : "-"}
                                </td>
                                <td>
                                  {indent?.employee_name
                                    ? indent?.employee_name
                                    : "-"}
                                </td>
                                <td>
                                  {indent?.department
                                    ? indent?.department
                                    : "-"}
                                </td>
                                <td>
                                  {moment(indent?.requested_date).format(
                                    "DD MMM YY"
                                  )}
                                </td>
                                <td className="viewoption">
                                  <Link
                                    to={`/app/Stores/StoreInchargeIndentSpecificView/${indent?.id}`}
                                  >
                                    View
                                  </Link>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td></td>
                              <td></td>
                              <td>
                                <div> No Data Found</div>
                              </td>
                              <td></td>
                              <td></td>
                            </tr>
                          )}
                        </tbody>
                      ) : (
                        <tbody>
                          {approveLeaveLength > 0 ? (
                            indentList &&
                            indentList
                              ?.filter(
                                (indentList) =>
                                  indentList.director_status === "approved"
                              )
                              .map((indent, index) => (
                                <tr key={index}>
                                  <td>
                                    {indent?.indent_number
                                      ? indent?.indent_number
                                      : "-"}
                                  </td>
                                  <td>
                                    {indent?.employee_name
                                      ? indent?.employee_name
                                      : "-"}
                                  </td>
                                  <td>
                                    {indent?.department
                                      ? indent?.department
                                      : "-"}
                                  </td>
                                  <td>
                                    {moment(indent?.requested_date).format(
                                      "DD MMM YY"
                                    )}
                                  </td>
                                  <td className="viewoption">
                                    <Link
                                      to={`/app/Director/DirectorIndentspecificsview/${indent?.id}`}
                                    >
                                      View
                                    </Link>
                                  </td>
                                </tr>
                              ))
                          ) : (
                            <tr>
                              <td></td>
                              <td></td>
                              <td>
                                <div> No Data Found</div>
                              </td>
                              <td></td>
                              <td></td>
                            </tr>
                          )}
                        </tbody>
                      )}
                    </table>
                  </>
                )}
                {active === 3 && (
                  <table className="table table-hover mt-5">
                    <thead>
                      <tr>
                        <th scope="col">Indent No</th>
                        <th scope="col">Name</th>
                        <th scope="col">Department</th>
                        <th scope="col">Date</th>
                        <th scope="col">Application</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rejectLeaveLength > 0 ? (
                        indentList &&
                        indentList
                          ?.filter(
                            (indentList) =>
                              indentList.director_status === "Rejected"
                          )
                          .map((indent, index) => (
                            <tr key={index}>
                              <td>
                                {indent?.indent_number
                                  ? indent?.indent_number
                                  : "-"}
                              </td>
                              <td>
                                {indent?.employee_name
                                  ? indent?.employee_name
                                  : "-"}
                              </td>
                              <td>
                                {indent?.department ? indent?.department : "-"}
                              </td>
                              <td>
                                {moment(indent?.requested_date).format(
                                  "DD MMM YY"
                                )}
                              </td>
                              <td className="viewoption">
                                <Link
                                  to={`/app/Director/DirectorIndentspecificsview/${indent?.id}`}
                                >
                                  View
                                </Link>
                              </td>
                            </tr>
                          ))
                      ) : (
                        <tr>
                          <td></td>
                          <td></td>
                          <td>
                            <div> No Data Found</div>
                          </td>
                          <td></td>
                          <td></td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default DirectorIndentlistrequest;
